import {unauthenticatedRoutes as manifest} from '@tenant/core/routes';
import resolveWebRoutes from './resolve';

/**
 * Unauthenticated web routes.
 *
 * @param {object} args - Auth state.
 * @returns {object[]}
 */
const unauthenticatedRoutes = args =>
  resolveWebRoutes(manifest(args), {authenticated: false});

export default unauthenticatedRoutes;
